import { FC, MouseEvent } from 'react'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Box from '@mui/material/Box'
import TableSortLabel from '@mui/material/TableSortLabel'
import { visuallyHidden } from '@mui/utils'

export type CustomersSortOrder = 'asc' | 'desc'

/** Поля, по которым можно сортировать список клиентов */
export type CustomersSortField =
  | 'id'
  | 'first_name'
  | 'last_name'
  | 'phone'
  | 'email'
  | 'city'
  | 'pizzeria_id'
  | 'orders_count'
  | 'orders_total_sum'
  | 'create_at'
  | 'last_order_at'

export interface CustomersHeadCell {
  id: CustomersSortField
  label: string
  disablePadding?: boolean
}

interface CustomersTableHeadProps {
  /** Текущее направление сортировки */
  order: CustomersSortOrder
  /** Текущее поле сортировки */
  orderBy: CustomersSortField
  /** Описание колонок */
  headCells: CustomersHeadCell[]
  /**
   * Запрос смены сортировки.
   * @param event — событие клика
   * @param property — поле сортировки
   */
  onRequestSort: (
    event: MouseEvent<unknown>,
    property: CustomersSortField
  ) => void
}

/**
 * Заголовок таблицы клиентов с TableSortLabel.
 * @param order — направление
 * @param orderBy — активное поле
 * @param headCells — колонки
 * @param onRequestSort — колбэк
 */
const CustomersTableHead: FC<CustomersTableHeadProps> = ({
  order,
  orderBy,
  headCells,
  onRequestSort,
}) => {
  /**
   * Создаёт обработчик клика по колонке.
   * @param property — поле сортировки
   */
  const createSortHandler =
    (property: CustomersSortField) => (event: MouseEvent<unknown>) => {
      onRequestSort(event, property)
    }

  return (
    <TableHead>
      <TableRow>
        <TableCell>N#</TableCell>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align='right'
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component='span' sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell align='right'>Пароль</TableCell>
      </TableRow>
    </TableHead>
  )
}

export default CustomersTableHead
